<div class="agb">
  <div class="agb-copy">
    <strong>One network. Every {{ networkName }} {{ groupsLabel | lowercase }}.</strong>
    <span>Explore member experiences without losing your preferences.</span>
  </div>
  <div class="agb-buttons">
    <button type="button" *ngFor="let group of groups" class="agb-btn" [class.agb-btn--active]="isActive(group)"
      [title]="groupName(group)" (click)="groupSelected.emit(group)">
      {{ groupName(group) }}
    </button>
    <button type="button" class="agb-btn agb-btn--all" [class.agb-btn--active]="!currentGroupSlug" (click)="openAll.emit()">
      All {{ groupsLabel }} ↗
    </button>
  </div>
</div>
